import type {
  ApiResponse,
  AvailabilityWatch,
  AvailabilityWatchWithProfessional,
  CreateAvailabilityWatchResponse,
} from '@klaro7/shared-types';

import api from '@/lib/api';

const BASE = '/availability-watch';

export async function createAvailabilityWatch(
  professionalId: string
): Promise<CreateAvailabilityWatchResponse> {
  const response = await api.post<ApiResponse<CreateAvailabilityWatchResponse>>(BASE, {
    professionalId,
  });
  return response.data.data;
}

export async function deleteAvailabilityWatch(professionalId: string): Promise<void> {
  await api.delete(`${BASE}/${professionalId}`);
}

export interface ListAvailabilityWatchesResponse {
  watches: AvailabilityWatchWithProfessional[];
  total: number;
  page: number;
  totalPages: number;
}

export async function listAvailabilityWatches(params?: {
  limit?: number;
  page?: number;
}): Promise<ListAvailabilityWatchesResponse> {
  const response = await api.get<ApiResponse<ListAvailabilityWatchesResponse>>(`${BASE}/mine`, {
    params,
  });
  return response.data.data;
}

export type { AvailabilityWatch, AvailabilityWatchWithProfessional, CreateAvailabilityWatchResponse };
